import { createSelector } from 'reselect';

export interface MetaState {
  cities: any[];
  factories: any[];
  markets: any[];
  countries: any[];
  regions: any[];
  collections: any[];
}
export const initialState = {
  cities: [],
  factories: [],
  markets: [],
  countries: [],
  regions: [],
  collections: [],
};

const getMeta = ({ meta }: any): MetaState => meta;

export const metaSelectors = {
  getCities: createSelector(
    getMeta,
    ({ cities }) => cities,
  ),
  getFactories: createSelector(
    getMeta,
    ({ factories }) => factories,
  ),
  getMarkets: createSelector(
    getMeta,
    ({ markets }) => markets,
  ),
  getCountries: createSelector(
    getMeta,
    ({ countries }) => countries,
  ),
  getRegions: createSelector(
    getMeta,
    ({ regions }) => regions,
  ),
  getAllEntities: createSelector(
    getMeta,
    entities => entities,
  ),
  getCollections: createSelector(
    getMeta,
    ({ collections }) => collections,
  ),
};



// WEBPACK FOOTER //
// ./src/store/meta/selectors.ts